import { Helmet } from "react-helmet";
import NotFoundLayout from "../sections/errors/notFoundLayout";

const NotFoundPage = () => {
    return (
        <>
            <Helmet>
                <title>Page Not Found | code3x</title>
            </Helmet>

            <NotFoundLayout />
        </>
    );
}

export default NotFoundPage;